import React, {useEffect, useRef, useState} from "react";
import apiClient from "../axios/axiosInterceptor";
import Dialog from "@mui/material/Dialog";
import {Box, FormControl, InputLabel, MenuItem, Select} from "@mui/material";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import TextField from "@mui/material/TextField";
import DialogFormActions from "../shared/DialogFormActions";

function VoiceCreate({ voice, onClose, onSubmit }) {
    const [name, setName] = useState(voice ? voice.name : '');
    const [friendlyName, setFriendlyName] = useState(voice ? voice.friendlyName : '');
    const [ttsServiceProviderId, setTtsServiceProviderId] = useState(voice ? voice.ttsServiceProviderId : '');
    const [languageLocaleId, setLanguageLocaleId] = useState(voice ? voice.languageLocaleId : '');
    const [genderId, setGenderId] = useState(voice ? voice.genderId : '');

    const [ttsServiceProviders, setTtsServiceProviders] = useState([]);
    const [languageLocales, setLanguageLocales] = useState([]);
    const [genders, setGenders] = useState([]);

    const dialogRef = useRef(null);

    useEffect(() => {
        const fetchTTSServiceProviders = async () => {
            const url = `/ttsServiceProviders`;
            const response = await apiClient.get(url);
            setTtsServiceProviders(response.data.list);
        };

        const fetchLanguageLocales = async () => {
            const url = `/languageLocales`;
            const response = await apiClient.get(url);
            setLanguageLocales(response.data.list);
        };

        const fetchGenders = async () => {
            const url = `/genders`;
            const response = await apiClient.get(url);
            setGenders(response.data);
        };

        fetchTTSServiceProviders();
        fetchLanguageLocales();
        fetchGenders();
    }, []);

    const handleSubmit = e => {
        e.preventDefault();
        onSubmit({ name, friendlyName, ttsServiceProviderId, languageLocaleId, genderId });
    };

    const handleClose = (event: {}, reason: "backdropClick" | "escapeKeyDown") => {
        if (reason === "backdropClick" || reason === "escapeKeyDown") {
            return;
        }
        onClose();
    };

    return (
        <React.Fragment>
            <Dialog
                open={true}
                onClose={handleClose}
                className="core-dialog"
            >
                <Box ref={dialogRef}>
                    <DialogTitle sx={{fontWeight: 'bold'}}>{voice ? 'Edit' : 'Create'} Voice</DialogTitle>
                    <form
                        onSubmit={handleSubmit}
                        style={{display: 'contents'}}
                        className="core-form"
                    >
                        <DialogContent className="core-dialog-content">
                            <div className="core-form-row-item">
                                <TextField
                                    autoFocus
                                    required
                                    margin="dense"
                                    id="name"
                                    label="Name"
                                    name="name"
                                    variant="standard"
                                    value={name}
                                    fullWidth
                                    onChange={e => setName(e.target.value)}
                                />
                            </div>

                            <div className="core-form-row-item">
                                <TextField
                                    autoFocus
                                    required
                                    margin="dense"
                                    id="friendlyName"
                                    label="Friendly Name"
                                    name="friendlyName"
                                    variant="standard"
                                    value={friendlyName}
                                    fullWidth
                                    onChange={e => setFriendlyName(e.target.value)}
                                />
                            </div>

                            <div className="core-form-row-item">
                                <FormControl fullWidth>
                                    <InputLabel id="ttsServiceProviderLabel">Select a TTS Service Provider</InputLabel>
                                    <Select
                                        labelId="ttsServiceProviderLabel"
                                        id="ttsServiceProviderId"
                                        value={ttsServiceProviderId}
                                        label="TTS Service Provider"
                                        onChange={e => setTtsServiceProviderId(parseInt(e.target.value))}
                                        variant={'outlined'}
                                    >
                                        {ttsServiceProviders.map(ttsServiceProvider => (
                                            <MenuItem value={ttsServiceProvider.id}>{ttsServiceProvider.name}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </div>

                            <div className="core-form-row-item">
                                <FormControl fullWidth>
                                    <InputLabel id="languageLocaleLabel">Select a Language Locale</InputLabel>
                                    <Select
                                        labelId="languageLocaleLabel"
                                        id="languageLocale"
                                        value={languageLocaleId}
                                        label="Language Locale"
                                        onChange={e => setLanguageLocaleId(parseInt(e.target.value))}
                                        variant={'outlined'}
                                    >
                                        {languageLocales.map(languageLocale => (
                                            <MenuItem value={languageLocale.id}>{languageLocale.name}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </div>

                            <div className="core-form-row-item">
                                <FormControl fullWidth>
                                    <InputLabel id="genderLabel">Select a Gender</InputLabel>
                                    <Select
                                        labelId="genderLabel"
                                        id="gender"
                                        value={genderId}
                                        label="Gender"
                                        onChange={e => setGenderId(parseInt(e.target.value))}
                                        variant={'outlined'}
                                    >
                                        {genders.map(gender => (
                                            <MenuItem value={gender.id}>{gender.name}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </div>

                        </DialogContent>
                        <DialogFormActions dialogRef={dialogRef} onClose={onClose}></DialogFormActions>
                    </form>
                </Box>
            </Dialog>
        </React.Fragment>
    );
}

export default VoiceCreate;
